import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';

import { CartItem, isCartItemAvailable } from '@/entities/cart';
import { formatPrice, getProductUrl } from '@/shared/lib';
import { Bullet } from '@/shared/ui';

import styles from './cartItemShort.module.scss';

interface CartItemShortProps {
  item: CartItem;
  className?: string;
}

const CartItemShort: FC<CartItemShortProps> = (props) => {
  const { item, className } = props;
  const { product, selectedPrice, quantity } = item;
  const isAvailable = isCartItemAvailable(item);

  return (
    <article
      className={classNames(
        styles.container,
        !isAvailable && styles.container_unavailable,
        className,
      )}
    >
      <Link
        className={styles.container__wrapper}
        href={getProductUrl(product)}
      >
        <div className={styles.container__imageBlock}>
          <Image
            alt={product.name}
            className={styles.container__image}
            height={80}
            src={product.image}
            width={80}
          />
          <Bullet
            className={styles.container__bullet}
            count={quantity}
            variant="border-black-24"
          />
        </div>
        <div className={styles.container__content}>
          <div>
            <p>{product.name}</p>
            {!isAvailable && (
              <p className={styles.container__stock}>Нет в наличии</p>
            )}
          </div>
          <div className={styles.container__row}>
            <p>{selectedPrice.name}</p>
            <div>
              <p>
                {formatPrice(
                  selectedPrice.price_with_personal_discount ??
                    selectedPrice.price ??
                    0,
                )}
              </p>
              <p>{formatPrice(selectedPrice.old_price ?? 0)}</p>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
};

export default CartItemShort;
